
<!-- 
DieCheckModal.vue
功能：回報視窗(身故確認&未辦理原因)
作者：i9400538 陳博承
完成：2021-12-03
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 v-if="action=='1'" class="modal-title">保戶身故狀況回報</h3>
          <h3 v-if="action=='2'" class="modal-title">保戶身故未辦理原因回報</h3>
          <h3 v-if="action=='3'" class="modal-title">身故待辦項目查詢</h3>
        </div>
        <!-- action:1 保戶身故狀況回報 -->
        <!-- 初始區塊 -->
        <div v-if="action == '1' && type=='1'">
          <div class="text-center">
            <h3>請確認保戶{{cust.name}}是否已身故?</h3>
            <div class="radio radio-inline">
              <input type="radio" value="1" id="r1" v-model="visit_reply" data-vv-as="已身故" />
              <label for="r1">已身故</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" value="2" id="r2" v-model="visit_reply" data-vv-as="未身故" />
              <label for="r2">未身故</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" value="3" id="r3" v-model="visit_reply" data-vv-as="無法會晤確認" />
              <label for="r3">無法會晤確認</label>
            </div>
            <div v-show="visit_reply=='2'">
              <select v-model="visit_way" id="visit_way">
                <option value>請選擇</option>
                <option
                  v-for="(item, index) in visit_way_sel"
                  :key="index"
                  :value="item.val"
                >{{item.text}}</option>
              </select>
            </div>
          </div>
          <br />
          <div class="text-center">
            <button
              v-if="(visit_reply=='1'||visit_reply=='3')||(visit_reply=='2'&&visit_way)"
              type="button"
              class="btn btn-primary"
              @click="nextstep"
            >下一步</button>
            <button v-else type="button" class="btn btn-primary" disabled="true">下一步</button>
          </div>
        </div>
        <!-- 下一步 block -->
        <div v-if="action == '1' && type=='2'" class="min-h">
          <label>您回報的結果為 : 保戶{{cust.name}}&nbsp;</label>
          <label class="text-red">{{visit_reply | getVisitReplyText}}</label>
          <label>
            。
            <br />是否確認無誤?
            <br />
            <br />
          </label>
          <label class="text-red">回報結果將嚴重影響保戶權益，請確認回報結果正確性再送出!!</label>
          <br />
          <br />
          <div class="text-center">
            <button type="button" class="btn-cancel" @click="cancel">取消</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('submit', visit_reply, visit_way)"
            >提交</button>
          </div>
        </div>
        <!-- action:2 保戶身故未辦理原因回報 -->
        <!-- 初始區塊 -->
        <div v-if="action == '2' && type!='3'">
          <div class="text-center">
            <h3>保戶{{cust.name}}</h3>
            <div class="radio radio-inline">
              <input
                type="radio"
                value="1"
                id="r1-action2"
                v-model="reply_cause"
                data-vv-as="保戶家屬已知悉不辦理"
              />
              <label for="r1-action2">保戶家屬已知悉不辦理</label>
            </div>
            <br />

            <div class="radio radio-inline">
              <input
                type="radio"
                value="2"
                id="r2-action2"
                v-model="reply_cause"
                data-vv-as="保戶家屬無法聯繫或拒訪"
              />
              <label for="r2-action2">保戶家屬無法聯繫或拒訪</label>
            </div>
            <br />

            <label>備註:&nbsp;</label>
            <input type="text" id="reply_memo-tet" v-model="reply_memo" class="input-txt" />
            <br />
            <br />
            <label class="text-red">提醒您，一經回報則無法修改!!</label>
          </div>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="apply" :disabled="!reply_cause">提交</button>
          </div>
        </div>
        <!-- 提交 block -->
        <div v-if="action == '2' && type=='3'" class="min-h">
          <label class="text-red">回報結果將嚴重影響保戶權益，請確認回報結果正確性再送出!!</label>
          <br />
          <br />
          <div class="text-center">
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('accept', reply_cause, reply_memo)"
            >確定送出</button>
          </div>
        </div>
        <!-- action:3 身故待辦項目查詢 -->
        <div v-if="action == '3'">
          <div class="div-content">
            <span>
              保戶{{cust.name}}身故通報來源為 :
              <label class="text-red">{{cust.insr_type | getInSrText}}</label>
            </span>
            <br />
            <span v-if="cust.insr_type == '3' || cust.insr_type =='4' || cust.insr_type == '5'">
              請先委婉確認保戶是否已身故，
              <br />如已身故再協助家屬申辦身故待辦項目
            </span>
            <span v-else>請聯繫家屬申辦身故待辦項目</span>
          </div>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="$emit('query')">點我查詢</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {commonMixin} from '@/mixins/common'
export default {
  name: "DieCheckModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "1"
    },
    cust: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      type: "1",
      visit_reply: "", //身故確認狀態
      visit_way: "", //未身故確認方式
      visit_way_sel: [
        { val: 1, text: "親晤" },
        { val: 2, text: "電話聯繫" }
      ],
      reply_cause: "", //未辦理原因
      reply_memo: "" //未辦理原因備註
    };
  },
  watch: {
    open: function() {
      this.init();
    },
    reply_memo: function() {
      this.reply_memo = this.cleanSpecialChar(this.reply_memo, '~()!');
    },
  },
  filters: {
    //身故通報來源
    getInSrText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "1") {
        text = "戶政除戶";
      } else if (val == "2") {
        text = "公司理賠";
      } else if (val == "3") {
        text = "其他公家機關";
      } else if (val == "4") {
        text = "同業通報";
      } else if (val == "5") {
        text = "其他";
      }
      return text;
    },
    getVisitReplyText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "1") {
        text = "已身故";
      } else if (val == "2") {
        text = "未身故";
      } else if (val == "3") {
        text = "無法會晤確認";
      }
      return text;
    }
  },
  methods: {
    //初始化
    init() {
      this.type = "1";
      this.visit_reply = "";
      this.visit_way = "";
      this.reply_cause = "";
      this.reply_memo = "";
    },
    //下一步
    nextstep() {
      this.type = "2";
    },
    //取消
    cancel() {
      this.type = "1";
    },
    //提交
    apply() {
      this.type = "3";
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.min-h {
  padding: 20px 40px;
  min-height: 190px;
  line-height: 1.5;
  position: relative;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
}
.btn-cancel {
  color: #fff;
  border: 1px solid #c66f1c;
  border-radius: 4px;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #c2c4c7 !important;
  display: inline-block;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.input-txt {
  border: 1px solid #c2c4c7;
  border-radius: 4px;
}
.div-content {
  padding-top: 1.2rem;
  padding-left: 30%;
  font-size: 18px;
}
</style>